export const SpzToVinProvider = {
    Allianz: 0,
    Axa: 1,
    Pillow: 2
} as const

export type SpzToVinProvider = typeof SpzToVinProvider[keyof typeof SpzToVinProvider]

export const SpzToVinProviders: [SpzToVinProvider, string][] = [
    [SpzToVinProvider.Allianz, 'Allianz'],
    [SpzToVinProvider.Axa, 'Axa'],
    [SpzToVinProvider.Pillow, 'Pillow']
]

export const getSpzToVinProviderName = (provider?: SpzToVinProvider) => {
    const found = SpzToVinProviders.find(x => x[0] === provider)
    return found ? found[1] : undefined
}
